import React, { useState, useEffect } from 'react';
import { Toast } from 'primereact/toast';
import Form from 'react-bootstrap/Form';
import './tickets.css';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'react-bootstrap';
import UploadIcon from '../../assets/icons/ticket/upload.svg';
import { addTicket, GetAllOrders } from '../../utils/api';
import useToastNotification from '../../hooks/useToastNotification';
import Loadr from '../loader/loader';
import moment from 'jalali-moment';

function AddTicket({ orderNum }) {
    const [loading, setLoading] = useState(false);
    const [validated, setValidated] = useState(false);
    const [orderNumber, setOrderNumber] = useState('');
    const [orderList, setOrderList] = useState([]);
    const [description, setDescription] = useState('');
    const [title, setTitle] = useState('');
    const [file, setFile] = useState(null);
    const { showError, showSuccess } = useToastNotification();
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [isOrderDisabled, setIsOrderDisabled] = useState(false);
    const [filePreview, setFilePreview] = useState(null);


    const convertDateToPersian = (date) => {
        if (!date) return '-';
        return moment(date).locale("fa").format("YYYY/MM/DD");
    };

    useEffect(() => {
        let customerDatares = window.localStorage.getItem('userInfo');
        let toDateNew = moment.now();
        let fd = new Date();
        fd.setMonth(fd.getMonth() - 12);
        let fromDateNew = fd;
        setToDate(toDateNew);
        setFromDate(fromDateNew);

        let pay = {
            fromDate: convertDateToPersian(fromDateNew),
            toDate: convertDateToPersian(new Date()),
            userId: JSON.parse(customerDatares).si,
            status: '',
            factorNum: ''
        };

        ordersData(pay);
    }, []);

    useEffect(() => {
        if (orderNum && orderList.length > 0) {
            console.log(orderNum)
            setOrderNumber(orderNum);
            setIsOrderDisabled(true);

        }
    }, [orderNum, orderList]);


    const ordersData = async (pay) => {
        try {
            let res = await GetAllOrders(pay);
            if (res.status === 200) {
                setOrderList(res.data);
            }
        } catch (error) {
            showError('خطا در دریافت سفارشات');
        }
    };

    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        setFile(selectedFile);

        if (selectedFile && selectedFile.type.startsWith('image/')) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setFilePreview(reader.result); // base64 image preview
            };
            reader.readAsDataURL(selectedFile);
        } else {
            setFilePreview(null);
        }
    };


    const handleFileClick = () => {
        document.getElementById('file-upload').click();
    };

    const submitTicket = async (e) => {
        e.preventDefault();
        const form = e.currentTarget;
        if (form.checkValidity() === false) {
            setValidated(true);
            return;
        }

        try {
            setLoading(true);
            const formData = new FormData();

            if (file) {
                formData.append('file', file);
            }
            const params = {
                title: title,
                desc: description,
                userId: JSON.parse(localStorage.getItem('userInfo')).si,
                orderId: orderNumber.Si
            };

            let res = await addTicket(formData, params);

            if (res.data.res === 'OK') {
                showSuccess(res.data.resTp);
            } else {
                showError(res.data.resTp);
            }
        } catch (error) {
            showError('خطا در برقراری ارتباط');
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Form className='mb-4' noValidate validated={validated} onSubmit={submitTicket}>
                <div className='row gx-5 gy-2'>
                    <Form.Group className={orderNum ? 'col-md-12 col-lg-12 col-sm-12' : 'col-md-6 col-lg-4 col-sm-12'}>
                        <Form.Label>سفارش مربوطه <span className='text-[red]'> * </span></Form.Label>
                        <Dropdown
                            value={orderNumber}
                            onChange={(e) => setOrderNumber(e.value)}
                            options={orderList}
                            optionLabel="Num"
                            className="w-100 number-font"
                            disabled={isOrderDisabled}
                        />
                    </Form.Group>

                    <Form.Group className={orderNum ? 'col-md-12 col-lg-12 col-sm-12' : 'col-md-6 col-lg-4 col-sm-12'} >
                        <Form.Label>موضوع <span className='text-[red]'> * </span></Form.Label>
                        <Form.Control type="text" required value={title} onChange={(e) => setTitle(e.target.value)} />
                        <Form.Control.Feedback type="invalid">
                            موضوع را وارد کنید.
                        </Form.Control.Feedback>
                    </Form.Group>
                </div>

                <div className='row gx-5 gy-2 mt-4'>
                    <Form.Group className={orderNum ? 'col-md-12 col-lg-12 col-sm-12' : 'col-md-6 col-lg-8 col-sm-12'}>
                        <Form.Label>توضیحات <span className='text-[red]'> * </span></Form.Label>
                        <Form.Control type="text" as="textarea" rows={3} required value={description} style={{ minHeight: '150px' }} onChange={(e) => setDescription(e.target.value)} />
                        <Form.Control.Feedback type="invalid">
                            توضیحات را وارد کنید.
                        </Form.Control.Feedback>
                    </Form.Group>
                </div>

                {/* File Upload Section */}
                <div className="row gx-5 gy-2 mt-4">
                    <Form.Group className={orderNum ? 'col-md-12 col-lg-12 col-sm-12' : 'col-md-6 col-lg-8 col-sm-12'}>
                        <div className="file-upload-container" onClick={handleFileClick}>
                            <input type="file" onChange={handleFileChange} id="file-upload" style={{ display: 'none' }} />
                            <img src={UploadIcon} alt="Upload Icon" />
                            <h6 className='text-xs font-medium mt-2'>
                                {file ? file.name : 'فایل مورد نظر را آپلود کنید.'}
                            </h6>
                        </div>
                    </Form.Group>
                    {filePreview && (
                        <div className=' '>
                            <img src={filePreview} alt="Preview" className="img-preview mt-2 aspect-[4/4] rounded-lg" width={150}  />
                        </div>
                    )}
                </div>

                <div className="mt-4 d-flex align-items-center justify-content-end">
                    <Button type="submit" className="btn btn-primary" disabled={loading}>
                        ثبت تیکت
                        {loading && <Loadr />}
                    </Button>
                </div>
            </Form>
        </>
    );
}

export default AddTicket;
